define(["./bootstrap-datetimepicker@4.17.43/src/js/bootstrap-datetimepicker.js"], function(main) {
  return main;
});
